<section role="region" class="companies__logos" *ngIf="(isMobile$ | async) === false">
  <ng-container *ngIf="logos$ | async as logos; else skeleton">
    <app-marquee-logo
      [logos]="logos | slice: 0:20"
      [pixelOffset]="1"
      [intervalDuration]="100"
      marqueeDirection="right"
    ></app-marquee-logo>
    <app-marquee-logo
      [logos]="logos | slice: 20:40"
      [pixelOffset]="1"
      [intervalDuration]="100"
      marqueeDirection="left"
    ></app-marquee-logo>
    <app-marquee-logo
      [logos]="logos | slice: 40:60"
      [pixelOffset]="1"
      [intervalDuration]="100"
      marqueeDirection="right"
    ></app-marquee-logo>
  </ng-container>
</section>

<ng-template #skeleton>
  <div class="skltn__logos">
    <ngx-skeleton-loader [count]="13" class="skltn__logo" [theme]="skltnLogo"></ngx-skeleton-loader>
  </div>

  <div class="skltn__logos">
    <ngx-skeleton-loader [count]="13" class="skltn__logo" [theme]="skltnLogo"></ngx-skeleton-loader>
  </div>

  <div class="skltn__logos">
    <ngx-skeleton-loader [count]="13" class="skltn__logo" [theme]="skltnLogo"></ngx-skeleton-loader>
  </div>
</ng-template>
